import { jsx } from "react/jsx-runtime";
import { Suspense, lazy } from "react";
import { useIsClient } from "@crehana/react-hooks";
const CookiesBanner = /*#__PURE__*/ lazy(()=>import("./CookiesBanner.js"));
const LazyCookiesBanner = ()=>{
    const isClient = useIsClient();
    if (!isClient) return null;
    return /*#__PURE__*/ jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ jsx(CookiesBanner, {})
    });
};
const CookiesBanner_LazyCookiesBanner = LazyCookiesBanner;
export default CookiesBanner_LazyCookiesBanner;
export { CookiesBanner, LazyCookiesBanner };
